import {rootActions} from "../DAL/store";
import {PluginSortStatusEnum} from "../enums";
import {sendGAEvent, sendGAEventAddToCart} from "../../../domain/marketing/gtm-provider";
import {SubscriptionPlanModel} from "../interfaces";
import { outbrainAddToCartEvent } from '../../../domain/marketing/outbrain-provider';

export const ToggleShowSortOptions = (ShowSortChoices : boolean,dispatch :any) => {
    dispatch(
        rootActions.main({
            ShowSortChoices:!ShowSortChoices
        })
    )
}
export const SortItems = (items : any[],PluginSortStatus : PluginSortStatusEnum) => {
    return items.sort((a, b) => {
        let value;
        if(PluginSortStatus === PluginSortStatusEnum.Popular){
            value = (a.sortPopular > b.sortPopular ? 1 : -1);
        }else if(PluginSortStatus === PluginSortStatusEnum.IncludedInPlan){
            value = (a.sortIncludes > b.sortIncludes ? 1 : -1);

        }else if(PluginSortStatus === PluginSortStatusEnum.ProductNameAZ){
            value =  (a.documentName.toLowerCase() > b.documentName.toLowerCase() ? 1 : -1);

        }else if(PluginSortStatus === PluginSortStatusEnum.ProductNameZA){
            value =  (a.documentName.toLowerCase() < b.documentName.toLowerCase() ? 1 : -1);

        }else{
            value = -1;
        }
        return value;
    });
}
export const SetIsAnnual = (isAnnual : boolean, dispatch :any) => {
    sendGAEvent('Toggle',isAnnual ? "Annual" : "Monthly");
    dispatch(
        rootActions.main({
            IsAnnual: isAnnual
        })
    )

}
export const HidePluginView = (dispatch :any) => {
    dispatch(
        rootActions.main({
            ShowPluginImageSortIncludesID : -1
        })
    )
};
export const StopPropagation = (event: any) => {
    //blocks parent's onclick event ( that with close the plugin's view )
    event.stopPropagation();
    return false;
}
export const AddToCart = (plan : SubscriptionPlanModel) => {

    outbrainAddToCartEvent();

    sendGAEventAddToCart(
        plan.skuName,
        plan.skuNumber,
        plan.skU_MSRP,
        plan.documentUrlPath,
        'Subscription Add To Cart'
    );

    window.location.href = "/cart?productid=" + plan.skuid;

}
/*Get parameter name
Returns the current URL's querystring with out this parameter*/
export const GetQueryWithNoParams = (paramNames : string[]) => {
    let url = new URL(window.location.href);
    let params = new URLSearchParams(url.search);
    paramNames.forEach(param => {
        // Delete the parameter of name paramName.
        params.delete(param);
    })
    return params.toString();
}



